import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import withScrolling from "react-dnd-scrolling";
import { openCurationSidebar, closeCurationSidebar } from "../GlobalActions";
import FadeIn from "react-fade-in";
import AlreadyExistPopup from "modules/EmailBrowser/Components/AlreadyExistPopup";
import { Switch, Route } from "react-router-dom";
import { hideTooltipPopupFirstTime } from "modules/Login/action";
import EmptyCurate from "../Common/Components/EmptyCurate";
import EmailsListContainer from "modules/EmailBrowser/Components/EmailsListContainer";
import CampaignEmailsList from "./Components/CampaignEmailsList";
import { ReactComponent as DropHere } from "../../assets/img/icons/nav/Drop.svg";
import { ReactComponent as CrossIcon } from "../../assets/img/icons/cross.svg";
import { getQueryCampaignId } from "./utils";
import CreateNewEmailButton from "modules/Common/Components/CreateNewEmailButton";

const ScrollingComponent = withScrolling("div");

const EmailBrowser = () => {
  /* state of the curation Sidebar */
  const location = useLocation();

  const isCuratedSidebar = useSelector((state) => state.uiReducer.curationSidebar);
  const alreadyExistAsset = useSelector((state) => state.emailBrowser.emailAlreadyExists);
  const [count, setCount] = useState(0);
  let campaignId = getQueryCampaignId();

  const emails = useSelector((state) => state.emailBrowser?.emails?.data);
  const emailsInCampaign = useSelector((state) => state.emailBrowser?.emailsInCampaign?.data);
  // const emailsInCampaign: any[] = useSelector((state) => state.emailBrowser?.emailsInCampaign?.data);
  const showPopup = useSelector((state) => state.user.showAssetBrowserPopup);
  const doNotShowPopup = useSelector((state) => state.user.isAssetBrowserPopupNotShowAgain);
  const allAssetsCount = useSelector((state) => state.emailBrowser.totalEmailsCount);
  const showRedColor = useSelector((state) => state.emailBrowser.showRedColor);
  // const contentExplorer = useSelector((state) => state.user.contentExplorer);
  const showCurationMessage = useSelector((state) => state.user.assets);
  // const contentExplorerStep = useSelector((state) => state.user.contentExplorerStep);
  // const isStickyHeaderEnabled = useSelector((state) => state.uiReducer.isStickyHeaderVisible);
  let assetBrowserRef = useRef();

  // const showPopup = true;
  const overFlowHidden = () => {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "20px";
  };

  // showing scrollbar when floating sidebar is closed
  const overFlowShow = () => {
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = 0;
  };

  const openSidebar = () => {
    if (showPopup) {
      hideTooltipPopupFirstTime();
    }
    if (isCuratedSidebar) {
      closeCurationSidebar();
      overFlowShow();
    } else {
      openCurationSidebar();
      overFlowHidden();
    }
    var elements = document.getElementsByClassName("disable-item");
    // document.querySelectorAll(".disable-item").forEach(function (item) {
    //   if (item.classList.contains("disable-item")) {
    //     item.classList.remove("disable-item");
    //   }
    // });

    if (assetBrowserRef.current) {
      assetBrowserRef.current.setAttribute("disabled", "disabled");
      return;
    }
  };

  useEffect(() => {
    if (isCuratedSidebar) overFlowHidden();
  }, [isCuratedSidebar]);

  //* cleanup function to close the floating sidebar
  useEffect(() => {
    return () => {
      closeCurationSidebar();
    };
  }, []);

  useEffect(() => {
    if (campaignId) {
      setCount(0);
    }
  }, [campaignId]);

  // useEffect(() => {
  //   if (pathname.startsWith("/content/")) {
  //     alert("fetched get Assets without campaign");
  //     getAssetsWithoutCampaignsList();
  //   }
  // }, []);

  // const newAssetCreatedCondition = () => {
  //   if (loaderAddingAssetWithoutCampaign) {
  //     return <BlogItemFourLoader />;
  //   } else {
  //     emailsWithoutCampaigns.map((data, index) => {
  //       return;
  //     });
  //   }
  // };

  return (
    <>
      <Wrapper className={` ${isCuratedSidebar ? "open" : ""}`}>
        {alreadyExistAsset && (
          <FadeIn>
            <AlreadyExistPopup />
          </FadeIn>
        )}
        {/* toggle open class to view right sidebar */}
        <div className="expandable">
          <div
            ref={assetBrowserRef}
            className={`opener ${showRedColor ? "articles-red" : ""}  top-padded-intersection `}
            onClick={openSidebar}
          >
            <div className="icon-container">
              <DropHere className="drop-here-icon" />
              <p className="drop-here-text">Drop here</p>
              {/* <span className="count">{allAssetsCount || 0}</span>
            {allAssetsCount > -1 ? <span className="count">{allAssetsCount}</span> : null} */}
            </div>
          </div>
          <div className="right-sidebar">
            <div className="container-sidebar">
              <div className="icon-cross">
                <CrossIcon style={{ cursor: "pointer" }} onClick={openSidebar} />
              </div>
              {/* Dialog box component to show some message */}
              <div className="header-section margin-top-xl">
                <div className="second-row padding-bottom-xl padding-bottom-tab-xl">
                  <h4>
                    Email <br /> builder
                  </h4>
                </div>
              </div>
              {/* {location.pathname.includes("campaigns") && emailsInCampaign.length === 0 && emails.length === 0 ? (
                <EmptyCurate />
              ) : location.pathname.startsWith("/content") && emails.length === 0 ? (
                <EmptyCurate />
              ) : null} */}
              {showCurationMessage ? <EmptyCurate /> : null}
              <CreateNewEmailButton />
              {!showCurationMessage ? (
                <div className="your-assets margin-top-md padding-right-md">
                  <h4 className="recent-heading">
                    {" "}
                    {window.location.pathname.includes("campaigns")
                      ? "Drop articles to add them to Emails in this campaign"
                      : "Drop articles to curate them to Emails"}
                  </h4>
                </div>
              ) : null}
              <ScrollingComponent id="emailBrowserList" className="curated-list">
                <Switch>
                  <Route exact path="/campaigns/content/:tab?" component={CampaignEmailsList} />
                  <Route
                    exact
                    path="/campaigns/editionedit/:tab?"
                    component={campaignId ? CampaignEmailsList : EmailsListContainer}
                  />
                  <Route path="/content/:tab" component={EmailsListContainer} />
                </Switch>
              </ScrollingComponent>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  right: -530px;
  position: fixed;
  min-width: 530px;
  top: 0;
  /* z-index: 14; */
  transition: 1s;
  z-index: 9;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    min-width: 410px;
    right: -410px;
  }
  &.open {
    right: 0px;
    transition: 1s;
    z-index: 14;
  }
  .expandable {
    display: flex;
    align-items: flex-start;
    min-height: 100vh;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 10%);
    border-left: 1px solid #cfcfcf;
    float: right;
    width: 100%;
    .right-sidebar {
      display: flex;
      align-items: flex-start;
      background: #fff;
      box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 10%);
      position: fixed;
      min-width: 530px;
      max-width: 530px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 410px;
        min-width: auto;
      }
      .container-sidebar {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
        padding: 25px 40px 0 60px;
        /* padding-bottom: 0px; */
        /* overflow: auto; */
        .icon-cross {
          position: absolute;
          right: 30px;
        }
        .your-assets {
          display: flex;
          justify-content: space-between;
        }
        .recent-heading {
          font-family: "robotomedium", sans-serif;
          font-size: 18px;
          color: #67696a;
          margin-top: 5px;
          margin-bottom: 5px;
          margin-left: 5px;
          @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 13px;
          }
        }
        .main-title {
          color: #67696a;
          font-size: 18px;
          font-family: "robotomedium", sans-serif;
          padding-left: 0.5em;
          padding-top: 20px;
          padding-bottom: 0px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 13px;
          }
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 15px 35px;
          width: 410px;
        }
        .loader {
          position: absolute;
          top: 50%;
          left: 50%;
          border-radius: 30px;
          background-color: rgba(54, 52, 49, 0.62);
          text-align: center;
          width: 325px;
          -webkit-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          z-index: 999;
          background-image: url(/static/media/PassiveNotification.1af2f17e.png);
          background-repeat: no-repeat;
          background-size: cover;
          height: 325px;
          display: flex;
          align-items: center;
        }
        .header-section {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            margin-top: 25px;
          }
          .first-row {
            display: flex;
            justify-content: flex-end;
          }
          .second-row {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            h4 {
              color: #424b50;
              font-size: 46px;
              font-family: 'Roboto Slab', serif;
              line-height: 0.98;
              margin-bottom: 0;
              font-weight: bold;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 32px;
              }
            }
          }
          .third-row {
            display: flex;
            justify-content: space-between;
            .left {
              display: flex;
            }
            .right {
              display: flex;
              justify-content: center;
              align-items: center;
              p {
                cursor: pointer;
                padding: 5px;
                margin: 0px;
                font-family: "robotomedium", sans-serif;
                font-size: 16px;
                color: #27ce0a;
              }
            }
          }
        }
      }
      .curated-list {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin-bottom: 30px;
        scrollbar-width: thin;
        scrollbar-color: #001760 transparent;
        height: calc(100vh - 150px);
        max-height: calc(100vh - 150px);
        overflow: auto;
        max-width: calc(100% + 15px);
        margin-right: -15px;
        &::-webkit-scrollbar {
          /* display: none; */
        }
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 0;
          margin-bottom: 5px;
          margin-left: 5px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      }
      .bottom-floating-action {
        border-top: 1px solid;
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        justify-content: center;
        background-color: #fff;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }
    }
    .top-padded-intersection {
      margin-top: 150px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 115px;
      }
    }
    .top-padded {
      margin-top: 65px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 30px;
      }
    }
    .opener {
      padding: 10px 14px;
      background: #fff;
      border: 2px solid #cfcfcf;
      /* border: 1px solid #cfcfcf; */
      border-right: none;
      border-radius: 7px 0 0 7px;
      margin-left: -78px;
      width: 78px;
      position: relative;
      cursor: pointer;
      float: left;
      box-shadow: 0 0 14px -2px rgba(0, 0, 0, 0.1);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-left: -60px;
        width: 60px;
        padding: 10px 8px;
        /* margin-top: 30px; */
      }
      .icon-container {
        display: flex;
        flex-direction: column;
        .drop-here-icon {
          height: 29px;
          width: 27px;
          margin: 0 auto;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: auto;
            width: 20px;
          }
        }
        .drop-here-text {
          color: #424b50;
          font-size: 12px;
          font-family: "Roboto";
          font-weight: 500;
          letter-spacing: -0.3px;
          line-height: 12px;
          margin-top: 6px;
          margin-bottom: 0;
          white-space: nowrap;
          text-align: center;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            line-height: 10px;
            font-size: 10px;
          }
        }
      }
      .count {
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        background: #424b50;
        border-radius: 9px;
        padding: 0 4px;
        position: absolute;
        top: 17px;
        right: 16px;
        font-family: "Roboto", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          top: 10px;
          right: 10px;
          font-size: 9px;
        }
      }
      &.articles-red {
        color: #fff;
        .count {
          background-color: #cc0000;
          border: none;
          box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 80%);
        }
      }
      .curated-tooltip {
        display: none;
        background-color: rgb(255, 255, 255);
        box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.29);
        padding: 35px 35px 35px 25px;
        position: absolute;
        top: -30px;
        right: 95px;
        width: 500px;
        border-radius: 8px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 360px;
          padding: 25px;
          right: 65px;
          top: -20px;
        }
        &:before {
          content: "";
          height: 100%;
          top: 0;
          right: -30px;
          position: absolute;
          width: 30px;
        }
        &:after {
          content: "";
          width: 30px;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid #fff;
          position: absolute;
          top: 55px;
          right: -30px;
        }
      }
      /* .curated-tooltip {
        display: block;
      } */
      .open-tool-tip {
        display: block;
      }
      .do-not-show {
        display: none !important;
      }
    }
  }
`;

export default EmailBrowser;
